import { render, staticRenderFns } from "./tab2-dypj.vue?vue&type=template&id=3f2930a2&scoped=true"
import script from "./tab2-dypj.vue?vue&type=script&lang=js"
export * from "./tab2-dypj.vue?vue&type=script&lang=js"
import style0 from "./tab2-dypj.vue?vue&type=style&index=0&id=3f2930a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2930a2",
  null
  
)

export default component.exports